<template>
<div class="hero_home version_1">
    <div class="content">

        <MedicClinicToggle v-model="searchMedics"/>
        
        <div v-if="searchMedics" class="mt-5">
            <h3 class="mb-4">¡Encontrá tu especialista!</h3>
            <SearchBar></SearchBar>
        </div>
        <div v-if="!searchMedics" class="mt-5" >
            <h3 class="mb-4">¡Encontrá tu exámen!</h3>
            <SearchClinicBar/>
        </div>

    </div>
</div>
</template>

<script>
import SearchBar from '@/components/SearchBar';
import SearchClinicBar from '@/components/SearchClinicBar';
import MedicClinicToggle from '@/components/MedicClinicToggle';


export default {
	name: "HomeSearchBar",
	components:{
        SearchBar,
        SearchClinicBar,
        MedicClinicToggle,
	},
	data(){
		return{
            searchMedics: true,
			searchInput: '',
            searchLocationInput:'',
            suggestOpen:false,
		}
	},
	methods:{
        startSearch(){
            let destinationUrl = '/doctors/' + this.searchLocationInput + '/' + this.searchInput;
            // console.log('redirect to',destinationUrl)
            this.$router.push(destinationUrl);
        }
	}
};
</script>

<style scoped>

.hero_home {
    height: 90vh;
    width: 100%;
    /* display: table; */
        display: flex;
    align-items: center;
    justify-content: center;
}

@media (max-width: 767px) {
    .hero_home {
        /* For less than 767px */
        height: 450px;
    }
}

.hero_home.version_1 {
    background: #e6e6e6 url(../assets/img/home-bk.jpg) no-repeat center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
}

@media (max-width: 767px) {
    .hero_home.version_1 {
        /* For less than 767px */
        height: 450px;
    }
}

.hero_home.version_1 .content {
    background-color: #363768;
    background-color: rgba(63, 64, 121, 0);
}

.hero_home .content {
    /* display: table-cell; */
    padding: 0;
    /* vertical-align: middle; */
    height: 250px;
    text-align: center;
    font-size: 21px;
    font-size: 1.3125rem;
    color: #333;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);
    background-color: #3e3f77;
    background-color: rgba(63, 64, 121, 0.9);
}

@media (max-width: 991px) {
    .hero_home .content {
        /* For less than 991px */
        padding: 0 30px;
    }
}

@media (max-width: 767px) {
    .hero_home .content {
        /* For less than 767px */
        font-size: 16px;
        font-size: 1rem;
        padding: 0 15px;
    }
}

.hero_home .content h3 {
    margin: 0 0 0 0;
    font-size: 60px;
    font-size: 2.75rem;
    font-weight: 700;
    text-transform: uppercase;
    color: #333;
}

@media (max-width: 767px) {
    .hero_home .content h3 {
        /* For less than 767px */
        font-size: 42px;
        font-size: 2.625rem;
    }
}

@media (max-width: 575px) {
    .hero_home .content h3 {
        /* For less than 575px */
        font-size: 32px;
        font-size: 2rem;
    }
}

/* Animations hero */
@keyframes pop-in {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
        -webkit-transform: scale(1.2);
        -moz-transform: scale(1.2);
        -ms-transform: scale(1.2);
        -o-transform: scale(1.2);
        transform: scale(1.2);
    }
}

/* Delay */
.hero_home .content h3.animated,
#hero_video .content h3.animated {
    animation-delay: 1s;
    -webkit-animation-delay: 1s;
    -moz-animation-delay: 1s;
    animation-duration: 0.4s;
    -webkit-animation-duration: 0.4s;
    -moz-animation-duration: 0.4s;
}

.hero_home .content p.animated,
#hero_video .content p.animated {
    animation-delay: 1.3s;
    -webkit-animation-delay: 1.3s;
    -moz-animation-delay: 1.3s;
    animation-duration: 0.4s;
    -webkit-animation-duration: 0.4s;
    -moz-animation-duration: 0.4s;
}

.hero_home .content form.animated,
#hero_video .content form.animated {
    animation-delay: 1.5s;
    -webkit-animation-delay: 1.5s;
    -moz-animation-delay: 1.5s;
    animation-duration: 0.3s;
    -webkit-animation-duration: 0.3s;
    -moz-animation-duration: 0.3s;
}

.hero_home .content .btn_1.animated,
#hero_video .content .btn_1.animated {
    animation-delay: 2s;
    -webkit-animation-delay: 2s;
    -moz-animation-delay: 2s;
    animation-duration: 1s;
    -webkit-animation-duration: 1s;
    -moz-animation-duration: 1s;
}


</style>
